import apiClient from './client'
import type { LoginCredentials, RegisterData, TokenResponse, User } from '@/types/auth'

export const authApi = {
  async login(credentials: LoginCredentials): Promise<TokenResponse> {
    const response = await apiClient.post<TokenResponse>('/auth/login', credentials)
    return response.data
  },

  async register(data: RegisterData): Promise<User> {
    const response = await apiClient.post<User>('/auth/register', data)
    return response.data
  },

  async getCurrentUser(): Promise<User> {
    const response = await apiClient.get<User>('/auth/me')
    return response.data
  },

  async logout(): Promise<void> {
    // No server-side session to invalidate; token is discarded client-side.
  }
}

export default authApi
